import React, { useState } from "react";
import { createPortal } from "react-dom";
import { toast } from "sonner";
import { UserPlus, X, Link2, Send, Loader2 } from "lucide-react";
import { api, formatApiError } from "../../lib/api";

// Host tool: invite wedding party members (or anyone with the link) to join the live on camera.
export function InviteParty({ bid, hostKey = "" }) {
  const [open, setOpen] = useState(false);
  const [d, setD] = useState(null);
  const [pick, setPick] = useState([]);
  const [busy, setBusy] = useState(false);
  async function load() { setOpen(true); try { const { data } = await api.post(`/broadcasts/${bid}/stage-invite`, { host_key: hostKey }); setD(data); } catch (e) { toast.error(formatApiError(e)); setOpen(false); } }
  async function send() {
    setBusy(true);
    try { const { data } = await api.post(`/broadcasts/${bid}/stage-invite`, { host_key: hostKey, guest_ids: pick }); toast.success(`Invited ${data.sent} to join on camera`); setPick([]); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  }
  const link = d ? d.link.replace(/^https?:\/\/[^/]+/, window.location.origin) : "";
  return (
    <>
      <button onClick={load} className="w-11 h-11 rounded-full bg-white/15 backdrop-blur flex items-center justify-center" aria-label="Invite on camera" data-testid="live-invite-party"><UserPlus className="w-5 h-5" /></button>
      {open && createPortal(
        <div className="fixed inset-0 z-[60] bg-black/60 flex items-end sm:items-center justify-center" onClick={() => setOpen(false)}>
          <div className="w-full sm:max-w-sm bg-white text-[#111] rounded-t-3xl sm:rounded-3xl p-5 max-h-[80vh] overflow-y-auto" onClick={(e) => e.stopPropagation()} data-testid="live-invite-modal">
            <div className="flex items-center justify-between mb-1"><p className="font-serif text-2xl">Invite on camera</p><button onClick={() => setOpen(false)} aria-label="Close"><X className="w-5 h-5" /></button></div>
            <p className="text-xs text-[var(--muted)] mb-4">Up to 6 people can be on camera together. Everyone else watches and can raise a hand.</p>
            {!d ? <Loader2 className="w-5 h-5 animate-spin text-[var(--gold)]" /> : <>
              <button onClick={() => { navigator.clipboard.writeText(link); toast.success("Link copied"); }} className="w-full flex items-center gap-2 border border-[var(--line)] rounded-xl px-3 py-2 text-xs mb-4 hover:border-[var(--gold)]" data-testid="live-invite-copy"><Link2 className="w-4 h-4 text-[var(--gold)]" /><span className="truncate flex-1 text-left">{link}</span>Copy</button>
              {d.party.length > 0 && <p className="text-[11px] uppercase tracking-wider text-[var(--gold)] mb-2">Wedding party</p>}
              <div className="space-y-1.5">
                {d.party.map((g) => (
                  <label key={g.guest_id} className={`flex items-center gap-2 text-sm ${g.reachable ? "" : "opacity-50"}`} data-testid={`live-invite-${g.guest_id}`}>
                    <input type="checkbox" disabled={!g.reachable} checked={pick.includes(g.guest_id)} onChange={(e) => setPick(e.target.checked ? [...pick, g.guest_id] : pick.filter((x) => x !== g.guest_id))} />
                    <span className="flex-1">{g.name} <span className="text-[11px] text-[var(--muted)]">{g.role}{g.reachable ? "" : " · no email/phone"}</span></span>
                  </label>
                ))}
              </div>
              {d.party.length > 0 && <button onClick={send} disabled={busy || !pick.length} className="btn-gold w-full mt-4 text-sm disabled:opacity-40" data-testid="live-invite-send">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Send invite</button>}
            </>}
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
